import { getStore } from '@/store'

export function showSuggestedCart (): boolean {
  const ArrayPermis = getStore()?.state.auth.user.permissionSchema ?? []
  const shipToId = localStorage.getItem('shipToId')
  const permissionScheme = ArrayPermis.find((item: any) => item.shipToId === shipToId)
  const isEligibleForSuggestedCart = permissionScheme?.rpDetails?.some((rp: any) => rp.permission === 'Suggested Cart')
  const suggestedCarts = getStore()?.state.basket.suggestedCarts

  return !!((suggestedCarts?.[0]?.shipping_address?.sap_id) && isEligibleForSuggestedCart)
}
